import React, {useEffect, useRef, useState} from "react";
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  FlatList,
  Linking,
  Dimensions,
  ActivityIndicator,
} from "react-native";
import {useDispatch, useSelector, connect} from "react-redux";
import {Color, globalFontStyle, globalStyle} from "../../../assets";

import {isMobile, trackMoengageEvent} from "../../../utils/commonMethods";
import NoMarket from "../../../commonComponents/NoMarkets";
import Colors from "../../../assets/Color/Colors";
import ContestCard from "./ContestCard";
import {
  getContestClose,
  getContestCoinsBalance,
  getContestLive,
  removeContest,
} from "../redux/contest.action";
import {useFocusEffect, useNavigation} from "@react-navigation/native";
import {globalImport} from "../../../common/globalImports";
import {RefreshControl} from "react-native-web-refresh-control";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {useSafeAreaInsets} from "react-native-safe-area-context";
import Header from "../../../commonComponents/Header";

const ContestTab = ({
  liveData,
  closeData,
  contestCardsLoading,
  getContestClose,
  getContestLive,
  removeContest,
}) => {
  const navigation = useNavigation();
  const [isLiveSelected, setIsLiveSelected] = useState(true);
  const insets = useSafeAreaInsets();
  const isAppLogin = useSelector(({utilReducer}) => utilReducer.isAppLogin);

  useFocusEffect(
    React.useCallback(() => {
      PullToRefresh();
    }, [isLiveSelected]),
  );

  const PullToRefresh = async () => {
    if (isLiveSelected) {
      getContestLive();
    } else {
      getContestClose();
    }
  };

  const timerExpireCallback = item => {
    if (Date.parse(item?.endsat) < Date.now()) {
      removeContest(liveData, item?.id);
    }
  };

  const renderFantasyCard = ({item, index}) => {
    return (
      <TouchableOpacity
        delayPressIn={0}
        key={item.id}
        onPress={() => {
          isLiveSelected
            ? navigation.push("Fantasy", {
                screen: "contestDetail",
                params: {contestId: item?.id},
              })
            : navigation.push("Fantasy", {
                screen: "LeaderBoard",
                params: {contestId: item?.id, contestDetails: item},
              });
        }}>
        <ContestCard
          data={item}
          isLiveSelected={isLiveSelected}
          timerExpireCallback={() => {
            timerExpireCallback(item);
          }}
        />
      </TouchableOpacity>
    );

    // return <ArticleCardWithImage items={item} handleArticlePress={handleArticlePress} />;
  };

  const onTabBtnPress = async val => {
    if (val && liveData?.contests?.length !== 0) {
      //getContestLive();
    } else if (!val && closeData?.contests?.length !== 0) {
      //getContestClose();
    }
    setIsLiveSelected(val);
  };

  const renderFooter = () => {
    return (
      <View
        style={{
          padding: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}>
        {contestCardsLoading ? (
          <ActivityIndicator size="large" color={Colors.black} />
        ) : null}
      </View>
    );
  };

  function contestHeaderComponent() {
    return (
      <>
        {isAppLogin && (
          <View style={styles.tabsParent}>
            <TouchableOpacity
              onPress={() => onTabBtnPress(true)}
              style={
                isLiveSelected
                  ? styles.headerOptionsSelected
                  : styles.headerOptions
              }>
              <FormTextLabel
                labelStyles={
                  isLiveSelected
                    ? {...globalFontStyle.appFontHeading, color: Colors.black}
                    : {
                        ...globalFontStyle.appFontHeadingRegular,
                        color: Colors.lightgrey,
                      }
                }
                label={"Active"}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => onTabBtnPress(false)}
              style={
                !isLiveSelected
                  ? styles.headerOptionsSelected
                  : styles.headerOptions
              }>
              <FormTextLabel
                labelStyles={
                  !isLiveSelected
                    ? {...globalFontStyle.appFontHeading, color: Colors.black}
                    : {
                        ...globalFontStyle.appFontHeadingRegular,
                        color: Colors.lightgrey,
                      }
                }
                label={"Settled"}
              />
            </TouchableOpacity>
          </View>
        )}
      </>
    );
  }

  const handleEmpty = () => {
    return <NoMarket source="contest" />;
  };

  return (
    <View
      style={[
        {
          backgroundColor: Color.bgWhite,

          paddingTop: insets.top,
          //paddingBottom: insets.bottom,
          paddingLeft: insets.left,
          paddingRight: insets.right,
        },
        isMobile() ? globalStyle.scroll_webFix : {},
      ]}>
      <Header
        isInternalPage={false}
        navigation={navigation}
        pageName={"Contest"}
        backGroundColor={"#FFFFFF"}
        translate={true}
      />
      <View style={{flex: 1, paddingHorizontal: 16, marginTop: 10}}>
        <FlatList
          // numColumns={3}
          //columnWrapperStyle={{ flex: 1, justifyContent: "space-around" }}
          contentContainerStyle={[
            {
              paddingBottom: isLiveSelected
                ? liveData?.contests?.length === 0
                  ? 0
                  : 350
                : closeData?.contests?.length === 0
                ? 0
                : 350,
            },
          ]}
          //columnWrapperStyle={{ flex: 1 }}
          ListHeaderComponent={contestHeaderComponent()}
          data={isLiveSelected ? liveData?.contests : closeData?.contests}
          renderItem={renderFantasyCard}
          ListEmptyComponent={handleEmpty}
          onRefresh={PullToRefresh}
          refreshing={contestCardsLoading}
          keyExtractor={(item, index) => item.id + ""}
          showsVerticalScrollIndicator={false}
          initialNumToRender={10}
          updateCellsBatchingPeriod={15}
          ListFooterComponent={globalImport.isWeb ? renderFooter : <></>}
          refreshControl={
            isMobile() ? (
              <RefreshControl
                colors={[Color.tradexBlue]}
                refreshing={contestCardsLoading}
                onRefresh={PullToRefresh}
              />
            ) : null
          }
        />
      </View>
    </View>
  );
};

const mapStateToProps = ({contestLeaderboardReducer}) => ({
  liveData: contestLeaderboardReducer.liveData,
  closeData: contestLeaderboardReducer.closeData,
  contestCardsLoading: contestLeaderboardReducer.contestCardsLoading,
});
const mapDispatchToProps = {
  getContestClose,
  getContestLive,
  removeContest,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContestTab);

const styles = StyleSheet.create({
  headerOptions: {
    ...globalFontStyle.appFontHeadingRegular,
    color: Colors.lightgrey,
    paddingVertical: 6,
    textAlign: "center",
    flex: 1,

    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  headerOptionsSelected: {
    ...globalFontStyle.appFontHeading,
    color: Colors.black,
    paddingVertical: 6,
    backgroundColor: Colors.bgWhite,
    borderRadius: 12,
    textAlign: "center",
    flex: 1,
    shadowColor: "#000",
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3,
    elevation: 2,

    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  tabsParent: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 15,
    backgroundColor: "rgba(244, 244, 244, 1)",
    borderRadius: 8,
    paddingVertical: 3,
    paddingHorizontal: 6,
  },
});
